import { render, staticRenderFns } from "./FlatCounter.vue?vue&type=template&id=6c32aad6&scoped=true&"
import script from "./FlatCounter.vue?vue&type=script&lang=js&"
export * from "./FlatCounter.vue?vue&type=script&lang=js&"
import style0 from "./FlatCounter.vue?vue&type=style&index=0&id=6c32aad6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32aad6",
  null
  
)

export default component.exports